import { SxProps, Theme } from '@mui/material';

export const styledTypographySx: SxProps<Theme> = (theme) => ({
	color: theme.palette.grey['500'],
});
